import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "../../../utils";

const toApiDate = (value) => {
    if (!value) return ''
    const parsed = moment(value, ['DD/MM/YYYY', 'YYYY-MM-DD'], true)
    return parsed.isValid() ? parsed.format('YYYY-MM-DD') : ''
}

export const paymentTransactionList = createAsyncThunk('paymentTransactionList', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + 'payment_transaction/list',
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                ...(data?.user_id ? { user_id: data.user_id } : {}),
                ...(data?.exam_id ? { exam_id: data.exam_id } : {}),
                ...(data?.payment_type ? { payment_type: data.payment_type } : {}),
                ...(data?.payment_status ? { payment_status: data.payment_status } : {}),
                ...(data?.reference_id ? { reference_id: data.reference_id } : {}),
                ...(toApiDate(data?.from_date) ? { from_date: toApiDate(data.from_date) } : {}),
                ...(toApiDate(data?.to_date) ? { to_date: toApiDate(data.to_date) } : {}),
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const paymentTransactionListSlice = createSlice({
    name: 'paymentTransactionList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(paymentTransactionList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = (() => {
                    const raw = action.payload.data.data;
                    return Array.isArray(raw) ? raw : (Object.values(raw || {}).find(Array.isArray) || []);
                })();
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }
        });
        builder.addCase(paymentTransactionList.rejected, () => { })
    }
})

export default paymentTransactionListSlice.reducer;
